import {
    Component, OnInit, Input, OnDestroy,
    AfterViewInit, ChangeDetectionStrategy,
    ChangeDetectorRef, ViewChild, SimpleChanges, OnChanges
} from '@angular/core';
// Animations
import { slideInDownAnimation } from '../../../app/app.animation';

import { ActivatedRoute, Router } from '@angular/router';

import { DatePipe } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FormCCService } from 'src/commons/services/formCC.service';

@Component({
    selector: 'accDist-table-component',
    templateUrl: 'accDist-table-component.html',
    styleUrls: ['accDist-table-component.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccDistTableComponent implements OnInit, OnChanges {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @Input() isLoading: boolean;
    @Input() data: any[];
    // @Input() displayedColumns: any[];

    public displayedColumns = ['code', 'description'];
    public dataSource: MatTableDataSource<any>;

    constructor(
        private ref: ChangeDetectorRef,
        private route: ActivatedRoute,
        private router: Router,
        private formCCService: FormCCService
    ) {
    }

    public ngOnInit() {
        setTimeout(() => {
            this.dataSource = new MatTableDataSource(this.data);
            // Sorting nested object
            this.dataSource.sortingDataAccessor = (item, property) => {
                switch (property) {
                    case 'code': return item.code.toLowerCase();
                    case 'description': return item.description.toLowerCase();
                    default: return item[property];
                }
            };
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
        });
    }

    public ngOnChanges(changes: SimpleChanges) {
        // console.log(changes);
        if (changes['data'] && changes['isLoading']) {
            setTimeout(() => {
                this.dataSource = new MatTableDataSource(changes['data'].currentValue);

                const datePipe = new DatePipe('en-US');
                this.dataSource.filterPredicate = (data, filter: string) => {
                    const accumulator = (currentTerm, key) => {
                        switch (key) {
                            default:
                                return currentTerm + data[key];
                        }
                        // return key === 'OrgInfo' ? currentTerm + data.OrgInfo.name : currentTerm + data[key];
                    };
                    const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
                    // Transform the filter by converting it to lowercase and removing whitespace.
                    const transformedFilter = filter.trim().toLowerCase();
                    return dataStr.includes(transformedFilter);
                };

                this.isLoading = changes['isLoading'].currentValue;
                // this.displayedColumns = changes.displayedColumns.currentValue;
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            });
        }
    }

    public getStatusClass(status): string {
        const possibleStatus = ['Submitted', 'Pending', 'Draft', 'Approved', 'Pending Approval', 'Rejected', 'Sent To Oracle', 'Waiting For Oracle', 'Withdrawn', 'Paid Credit', 'Check Cashed', 'Check Issued', 'Check Voided', 'Check Cleared', 'Cancelled'];
        return possibleStatus.indexOf(status) > -1 && status.toLowerCase();
    }

    public applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }
}
